const TMS_TOKEN_KEY = 'TMS_TOKEN';

export { TMS_TOKEN_KEY };
